// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  background: #f2f2f2;\n}\n#app {\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\nul,\nli {\n  list-style: none;\n  padding: 0px;\n  margin: 0px;\n}\nbody::-webkit-scrollbar {\n  display: none;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
